import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';

import { TwitterService } from './twitter.service';

@Component({
  template: `
     <p>conectando....</p>
  `,
})
export class TwitterLayoutComponent implements OnInit {

  constructor(private router:Router, private twitterService: TwitterService) {
    var token = router.parseUrl(router.url).queryParams["oauth_verifier"];
    this.twitterService.loginSuccess(token);
  }
  ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/social/twitter/twitter-layout.component.ts